/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import axios from '@/axios.js';

export default {
  SET_INTERNET_CONNECTION_STATUS(state, value) {
    state.internetConnectionStatus = value;
  },
  SET_USER_DATA(state, value) {
    state.data = value;
  },
  SET_PROFILE_PICTURE(state, value) {
    state.data.profilePictureUrl = value;
  },
  SET_DOB(state, value) {
    state.data.dob = value;
  },
  SET_GENDER(state, value) {
    state.data.gender = value;
  },
  SET_FIRST_NAME(state, value) {
    state.data.firstName = value;
  },
  SET_LAST_NAME(state, value) {
    state.data.lastName = value;
  },
  SET_CAREER_OBJECTIVE(state, value) {
    state.data.careerObjective = value;
  },
  SET_ABOUT(state, value) {
    state.data.about = value;
  },
  SET_PERSONAL_WEBSITE(state, value) {
    state.data.personalWebsite = value;
  },
  SET_SKYPE_PROFILE(state, value) {
    state.data.skypeProfile = value;
  },
  SET_FACEBOOK_PROFILE(state, value) {
    state.data.facebookProfile = value;
  },
  SET_CONTACT_NUMBER(state, value) {
    state.data.contactNumber = value;
  },
  SET_TWITTER_PROFILE(state, value) {
    state.data.twitterProfile = value;
  },
  SET_ADDRESS(state, value) {
    state.data.address = value;
  },
  SET_LINKEDIN_PROFILE(state, value) {
    state.data.linkedinProfile = value;
  },
  SET_DISCORD_PROFILE(state, value) {
    state.data.discordProfile = value;
  },
  SET_PROFESSION(state, value) {
    state.data.profession = value;
  },
  SET_TEMPLATE_COLOR_CODE(state, value) {
    state.data.templateColorCode = value;
  },
  SET_RESUME_STATUS(state, value) {
    state.data.resumeStatus = value;
  },
  SET_RESUME_TEMPLATE(state, value) {
    state.data.resumeTemplate = value;
  },
  SET_REVEAL_TERMS(state, value) {
    state.data.revealTermsStatus = value;
  },
  SET_SHOW_CAREER_HISTORY_ON_MAP(state, value) {
    state.data.showCareerHistoryOnMap = value;
  },
  SET_USERS_SUBSCRIBED_APPS(state, value) {
    state.subscribedApps = value;
  },
  SET_GALA_AVATAR(state, value) {
    if (value && value.data && value.data.avatar) {
      state.galaAvatar = value.data.avatar;
    } else {
      state.galaAvatar = "monk";
    }
  },
  SET_GALA_ABILITIES(state, value) {
    state.galaAbilities = value.data.abilities;
  },
  SET_GALA_PRIORITIES(state, value) {
    state.galaPriorities = value.data.priorities;
  },
};
